class FileUploader {
    constructor(files_handler, drag_enter_handler, drag_over_handler, drag_leave_handler, should_handle_paste = true) {
        this.files_handler = files_handler;
        this.drag_enter_handler = drag_enter_handler;
        this.drag_over_handler = drag_over_handler;
        this.drag_leave_handler = drag_leave_handler;
        this.should_handle_paste = should_handle_paste;
    }

    setupDropArea(element) {
        // unbind existing event listeners
        if (this.drop_area) {
            this.drop_area.removeEventListener('dragover', this.handleDragOver);
            this.drop_area.removeEventListener('dragenter', this.handleDragEnter);
            this.drop_area.removeEventListener('dragleave', this.handleDragLeave);
            this.drop_area.removeEventListener('drop', this.handleDrop);

            if (this.should_handle_paste) {
                this.drop_area.removeEventListener('paste', this.handlePaste);
            }
        }

        this.drop_area = element;
        this.drop_area.addEventListener('dragover', (event) => this.handleDragOver(event));
        this.drop_area.addEventListener('dragenter', (event) => this.handleDragEnter(event));
        this.drop_area.addEventListener('dragleave', (event) => this.handleDragLeave(event));
        this.drop_area.addEventListener('drop', (event) => this.handleDrop(event));

        if (this.should_handle_paste) {
            this.drop_area.addEventListener('paste', (event) => this.handlePaste(event));
        }
    }

    handleDragEnter(event) {
        if (this.drag_enter_handler) {
            this.drag_enter_handler(event);
        }
    }

    handleDragOver(event) {
        event.preventDefault();

        if (this.drag_over_handler) {
            this.drag_over_handler(event);
        }
    }

    handleDragLeave(event) {
        event.preventDefault();

        if (this.drag_leave_handler) {
            this.drag_leave_handler(event);
        }
    }

    handleDrop(event) {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (this.files_handler) {
            this.files_handler(files);
        }
    }

    handlePaste(event) {
        const items = event.clipboardData.items;
        const files = [];
        for (const item of items) {
            if (item.kind === 'file') {
                const file = item.getAsFile();
                if (file) {
                    files.push(file);
                }
            }
        }

        if (this.files_handler && files.length > 0) {
            this.files_handler(files);
        }

        if (files.length > 0) {
            event.preventDefault();
        }
    }
}

export default FileUploader;